import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Title from "../../components/title";
import { faHand } from "@fortawesome/free-solid-svg-icons";
import RegisterSelect from "../../components/RegisterSelect";
import RegisterTextbox from "../../components/RegisterTextBox";
import { Form, Row, Spinner } from "react-bootstrap";
import "./VacationRequest.css";
import CustomButton from "../../components/CustomButton";
import RegisterRadio from "../../components/Radio";
import UploadInput from "../../components/UploadInput";
import API from "../../api/axiosConfig";
import TestPreLoader from "../TestPreLoader/TestPreLoader";
import { useNavigate } from "react-router";
import "react-datepicker/dist/react-datepicker.css";

function VacationRequest() {
  const [selectedType, setSelectedType] = useState("");
  const [employees, setEmployees] = useState([]);
  const [vacations, setVacations] = useState([]);
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("");
  const [from, setFrom] = useState(new Date().toISOString().substr(0, 10));
  const [to, setTo] = useState(new Date().toISOString().substr(0, 10));
  const [vecType, setVecType] = useState("");
  const [leavedate, setLeavedate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [note, setNote] = useState("");
  const [hours, setHours] = useState(0);
  const [upload, setUpload] = useState("");
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitting2, setIsSubmitting2] = useState(false);

  const handleTypeChange = (value) => {
    setSelectedType(value);
  };
  useEffect(() => {
    setSelectedType("vac");
  }, []);

  // const handleFromDate = (date) => {
  //   const offset = new Date().getTimezoneOffset() * 60000; // Convert offset to milliseconds
  //   const localDate = new Date(date - offset).toISOString().split("T")[0];
  //   date = new Date(localDate);
  //   setFrom(date.toISOString().split("T")[0]);
  // };

  // const handleToDate = (date) => {
  //   const offset = new Date().getTimezoneOffset() * 60000; // Convert offset to milliseconds
  //   const localDate = new Date(date - offset).toISOString().split("T")[0];
  //   date = new Date(localDate);
  //   setTo(date.toISOString().split("T")[0]);
  // };

  // const handleLeaveDate = (date) => {
  //   const offset = new Date().getTimezoneOffset() * 60000; // Convert offset to milliseconds
  //   const localDate = new Date(date - offset).toISOString().split("T")[0];
  //   date = new Date(localDate);
  //   setLeavedate(date.toISOString().split("T")[0]);
  // };

  const handleSubmitVacation = async () => {
    setIsSubmitting(true);

    const mForm = new FormData();
    mForm.append("name", name);
    mForm.append("type", type);
    mForm.append("description", description);
    mForm.append("from", from);
    mForm.append("to", to);

    try {
      await API.post("vacationrequests/store", mForm);
      navigate("/hrreport/vacations");
    } catch (error) {
      setError(error.response.data.errors);
      setIsSubmitting(false);
    }
  };

  const handleSubmitPermission = async () => {
    setIsSubmitting2(true);

    const mForm = new FormData();
    mForm.append("name", name);
    mForm.append("vectype", vecType);
    mForm.append("date", leavedate);
    mForm.append("hours", hours);
    mForm.append("note", note);
    mForm.append("upload", upload);

    try {
      await API.post("/leaverequests/store", mForm, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      navigate("/hrreport/leavepermissionreport");
    } catch (error) {
      setError(error.response.data.errors);
      setIsSubmitting2(false);
    }
  };

  const getEmployee = async () => {
    try {
      const res = await API.post("employees");
      const data = await res;
      console.log(data.data);
      setEmployees(data.data);
      setLoading(false);
    } catch (error) {
      setError(error.response.data.errors);
    }
  };

  const getVacation = async () => {
    try {
      const res = await API.post("vacations");
      const data = await res;
      console.log(data.data);
      setVacations(data.data);
      setLoading(false);
    } catch (error) {
      setError(error.response.data.errors);
    }
  };

  useEffect(() => {
    getEmployee();
    getVacation();
  }, []);

  return loading ? (
    <TestPreLoader />
  ) : (
    <>
      <div className="vacationRequest-container">
        <Title
          title="طلب إذن"
          className="marketingtitle text-center"
          icon={<FontAwesomeIcon icon={faHand} />}
        />
        <div className="rediosCon">
          <div className="sexType">
            <h5 className="radTitle">النوع</h5>
            <div className="clientRadios clientRadios3">
              <RegisterRadio
                label="إذن"
                value="per"
                onChange={() => handleTypeChange("per")}
                checked={selectedType === "per"}
              />
              <RegisterRadio
                label="إجازة"
                value="vac"
                onChange={() => handleTypeChange("vac")}
                checked={selectedType === "vac"}
              />
            </div>
          </div>
        </div>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            if (selectedType === "vac") handleSubmitVacation();
            else handleSubmitPermission();
          }}
        >
          {selectedType === "vac" && (
            <div className="vacationInputs" id="1">
              <RegisterSelect
                id="empName"
                label="إسم الموظف"
                stylee={{ width: "45%" }}
                parentStyle={{ width: "45%", marginBottom: "20px" }}
                options={[
                  { value: "0", label: "اختر موظفا" },
                  ...employees.map((emp) => ({
                    value: emp.id,
                    label: emp.name,
                  })),
                ]}
                value={name}
                onChange={(e) => setName(e.target.value)}
                name="name"
              />
              {error && error.name && <div className="error">{error.name}</div>}
              <RegisterSelect
                id="vacType"
                label="نوع الإجازة"
                stylee={{ width: "45%" }}
                parentStyle={{ width: "45%", marginBottom: "20px" }}
                options={[
                  { value: "0", label: " اختر نوع الاجازة" },
                  ...vacations.map((vac) => ({
                    value: vac.id,
                    label: vac.name,
                  })),
                ]}
                value={type}
                onChange={(e) => setType(e.target.value)}
                name="type"
              />
              {error && error.type && <div className="error">{error.type}</div>}
              <RegisterTextbox
                parentStyle={{ width: "45%" }}
                id="vacDescription"
                label="وصف الإجازة"
                type="text"
                stylee={{ width: "45%" }}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                name="description"
              />
              {error && error.description && (
                <div className="error">{error.description}</div>
              )}
              <div className="vaca-times">
                {/* <RegisterTextbox
                  parentStyle={{
                    width: "20%",
                  }}
                  id="leaveTime"
                  label="من"
                  type="date"
                  stylee={{
                    width: "55%",
                  }}
                  onChange={handleFromDate}
                /> */}
                <p className="datelable">من</p>
                <input
                  type="date"
                  id="date"
                  onChange={(e) => setFrom(e.target.value)}
                  value={from}
                  className="custom-datepicker"
                  style={{ width: "80%", height: "42px" }}
                />
                {error && error.from && (
                  <div className="error">{error.from}</div>
                )}
                {/* <RegisterTextbox
                  parentStyle={{
                    width: "20%",
                  }}
                  id="arrivalTime"
                  label="الي"
                  type="date"
                  stylee={{
                    width: "55%",
                  }}
                  onChange={handleToDate}
                /> */}

                <p className="datelable">إلى</p>
                <input
                  type="date"
                  id="date"
                  onChange={(e) => setTo(e.target.value)}
                  value={to}
                  className="custom-datepicker"
                  style={{ width: "80%" }}
                />
                {error && error.to && <div className="error">{error.to}</div>}
              </div>
            </div>
          )}
          {selectedType === "per" && (
            <div className="vacationInputs" id="2">
              <RegisterSelect
                id="empName"
                label="إسم الموظف"
                stylee={{ width: "45%" }}
                parentStyle={{ width: "45%", marginBottom: "20px" }}
                options={[
                  { value: "", label: " اختر موظفا" },
                  ...employees.map((emp) => ({
                    value: emp.id,
                    label: emp.name,
                  })),
                ]}
                value={name}
                onChange={(e) => setName(e.target.value)}
                name="name"
              />
              {error && error.name && <div className="error">{error.name}</div>}
              <RegisterSelect
                id="vacType"
                label="نوع الإذن"
                stylee={{ width: "45%" }}
                parentStyle={{ width: "45%", marginBottom: "20px" }}
                options={[
                  { value: "1", label: "إستئذان خلال اليوم" },
                  { value: "2", label: "تأخير عن الدوام" },
                  { value: "3", label: "أنصراف مبكر" },
                  { value: "4", label: "مراجعة مستشفي خلال الدوام" },
                  { value: "5", label: " مرض" },
                  { value: "6", label: "حمل" },
                  { value: "7", label: " اخرى" },
                ]}
                value={vecType}
                onChange={(e) => setVecType(e.target.value)}
                name="vecType"
              />
              {error && error.vecType && (
                <div className="error">{error.vecType}</div>
              )}
              {/* <RegisterTextbox
                parentStyle={{ width: "45%", marginBottom: "20px" }}
                id="arrivalTime"
                label="التاريخ"
                type="date"
                stylee={{
                  width: "55%",
                }}
                onChange={handleLeaveDate}
                name="leavedate"
              /> */}

              <p style={{ width: "44%" }}>التاريخ</p>
              <input
                type="date"
                id="date"
                onChange={(e) => setLeavedate(e.target.value)}
                value={leavedate}
                className="custom-datepicker"
                style={{ width: "46%" }}
              />
              {error && error.leavedate && (
                <div className="error">{error.leavedate}</div>
              )}
              <RegisterTextbox
                parentStyle={{ width: "45%", marginBottom: "20px" }}
                id="hours"
                label="عدد الساعات"
                type="number"
                stylee={{
                  width: "55%",
                }}
                value={hours}
                onChange={(e) => setHours(e.target.value)}
                name="hours"
              />
              {error && error.hours && (
                <div className="error">{error.hours}</div>
              )}
              <RegisterTextbox
                parentStyle={{ width: "45%", marginBottom: "20px" }}
                id="note"
                label="ملاحظات"
                type="text"
                stylee={{
                  width: "55%",
                }}
                name="note"
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
              {error && error.note && <div className="error">{error.note}</div>}
              {error && error.upload && (
                <div className="error">{error.upload}</div>
              )}
            </div>
          )}

          <Row className="mb-3 mx-auto p-4 justify-content-center upload-image">
            {" "}
            {upload && (
              <div className="image p-0">
                {" "}
                <img
                  className="rounded-2"
                  src={URL.createObjectURL(upload)}
                  alt="صورة مرفوعة"
                />{" "}
              </div>
            )}{" "}
            <div style={{ marginTop: "25px" }}>
              {" "}
              <UploadInput
                id="empdocumentUpload"
                label="رفع  مرفق (إن وجد)"
                onChange={(e) => setUpload(e.target.files[0])}
                accept="image/*"
              />{" "}
            </div>{" "}
          </Row>
          {isSubmitting || isSubmitting2 ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div className="text-center">
              <CustomButton text="حفظ" />
            </div>
          )}
        </Form>
      </div>
    </>
  );
}

export default VacationRequest;
